import { SEOLinksControl } from 'modules/SEOLinking/components/SEOLinkingControl';
import React, { ReactNode } from 'react';
import FooterWrapper, { MenuWrapper, SecondaryFooter } from './Footer.style';

interface IFooter {
  className?: string;
  logo: ReactNode;
  menu: ReactNode;
  bgSrc?: string | ReactNode;
  copyright: string;
  path?: string;
}

export const Footers = ({ menu, bgSrc, className, path }: IFooter): JSX.Element => (
  <>
    <FooterWrapper id="footer" className={className} bg-img={bgSrc}>
      <SEOLinksControl />
      {menu && <MenuWrapper>{menu}</MenuWrapper>}
    </FooterWrapper>
    {!!path && <SecondaryFooter />}
  </>
);
